// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        numberFilterTree: 2,
        styleScrollToTop: 'style2',
    }
};

var bcSfFilterTemplate = {
    'saleLabelHtml': '<span class="label sale">' + bcSfFilterConfig.label.sale + '</span>',
    'soldOutLabelHtml': '<span class="label sold-out">' + bcSfFilterConfig.label.sold_out + '</span>',
    'saleTextHtml': '<span class="sale">' + bcSfFilterConfig.label.sale + '</span> ',
    'soldOutTextHtml': '<span class="sold-out">' + bcSfFilterConfig.label.sold_out + '</span> ',
    'vendorHtml': '<span class="vendor"><a href="{{itemVendorUrl}}">{{itemVendorLabel}}</a></span>',

    // Grid Template
    'productGridItemHtml': '<div class="box product">' +
                                '<figure class="product-grid-item--' + bcSfFilterConfig.custom.collections_text_alignment + '">' +
                                    '<a id="ProductGridImageWrapper-collection-template--{{itemId}}" href="{{itemUrl}}" class="product_card">' +
                                        '<div class="product_card__image-wrapper" data-bgset="{{itemBgset}}">' + 
                                            '{{itemImages}}' +
                                            '{{itemLabels}}' +
                                        '</div>' +
                                    '</a>' +
                                    '<figcaption>' +
                                        '<div class="product-title">' +
                                            '<a href="{{itemUrl}}" class="product-title">{{itemTitle}}</a>' +
                                            '{{itemVendor}}' +
                                        '</div>' +
                                        '<span class="price">{{itemPrice}}</span>' +
                                    '</figcaption>' +
                                '</figure>' +
                            '</div>',

    // List Template
    'productListItemHtml':  '<div class="box product">' +
                                '<figure>' +
                                    '<div class="product-thumbnail">' +
                                        '<a href="{{itemUrl}}" {{itemImageClass}}>' +
                                            '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                        '</a>' +
                                    '</div>' +
                                    '<figcaption>' +
                                        '<header>' +
                                            '<div class="product-title">' +
                                                '<a href="{{itemUrl}}" class="product-title">{{itemTitle}}</a>' +
                                                '{{itemVendor}}' +
                                            '</div>' +
                                            '<span class="price">{{itemSaleText}}{{itemSoldOutText}}{{itemPrice}}</span>' +
                                        '</header>' +
                                        '<div class="description rte"><p>{{itemDescription}}</p></div>' +
                                        '{{itemSaleLabel}}' +
                                        '{{itemSoldOutLabel}}' +
                                    '</figcaption>' +
                                '</figure>' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<li><a href="{{itemUrl}}" title="layout.pagination.previous_html">&larr;</a></li>',
    'nextHtml': '<li><a href="{{itemUrl}}" title="layout.pagination.next_html">&rarr;</a></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><a>{{itemTitle}}</a></li>',
    'pageItemRemainHtml': '<li class="ellipsis"><a href="#" onclick="return false;">{{itemTitle}}</a></li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label> <select>{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildProductGridItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add sale label
    var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.show_vendors ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor).replace(/{{itemVendorUrl}}/g, this.buildProductItemVendorUrl(data.vendor)) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add bgset
    var aspect_ratio = 1;
    if (images.length > 0) {
        aspect_ratio = images[0]['width'] / images[0]['height'];
    }
    itemHtml = itemHtml.replace(/{{itemBgset}}/g, bgset(images[0]));

    // Add item Images
    var itemImagesHtml = '';
    itemImagesHtml += '<img id="ProductGridImage-collection-template--{{itemId}}" class="product_card__image lazyload ';
    if (bcSfFilterConfig.custom.variant_rollover && images.length > 1) {
        itemImagesHtml += 'featured';
    }
    if (images.length > 0) {
    itemImagesHtml +=   '" src="' + this.optimizeImage(images[0]['src'], '295x') + '" data-src="' + this.optimizeImage(images[0]['src'], '{width}x')  + '" ' + 
                        'data-widths="[295,394,590,700,800,1000,1200,1500,1800,2000,2400]" data-aspectratio="' + aspect_ratio + '" data-sizes="auto" ' +
                        'data-expand="600" data-fallback="' + this.optimizeImage(images[0]['src'], '295x') + '" alt="{{itemTitle}}"' +
                        '>';
    itemImagesHtml +=   '<noscript>' + 
                            '<img class="product_card__image" src="' + this.optimizeImage(images[0]['src'], '295x')  + '" alt="{{itemTitle}}">' +
                        '</noscript>';
    } else {
        itemImagesHtml +=   '" src="' + "https://cdn.shopify.com/s/files/1/0089/2305/4143/files/no_image.png?60096" + '"style="height: 80%; width: 80%; left: 16px;"';
    }
    if (bcSfFilterConfig.custom.collections_product_ratio == 'false' || (bcSfFilterConfig.custom.collections_product_columns == '1' && bcSfFilterConfig.custom.collections_product_ratio == 'auto')) {
        itemImagesHtml +=   '<style media="screen">' + 
                                '#ProductGridImageWrapper-collection-template--{{itemId}} .product_card__image-wrapper:before { padding-bottom: ' + 1 / aspect_ratio * 100 + '%; }' +
                            '</style>';
    }
    if (bcSfFilterConfig.custom.variant_rollover && images.length > 1) {
        itemImagesHtml +=   '<img id="ProductGridImage1-collection-template--{{itemId}}" class="product_card__image alt lazyload" src="' + this.optimizeImage(images[1]['src'], '295x') + '" data-src="' + this.optimizeImage(images[1]['src'], '{width}x')  + '" ' + 
                            'data-widths="[295,394,590,700,800,1000,1200,1500,1800,2000,2400]" data-aspectratio="' + aspect_ratio + '" data-sizes="auto" ' +
                            'data-expand="600" alt="{{itemTitle}}"' +
                            '>';
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    //Add Label
    var itemLabelsHtml = '';
    if (soldOut) {
        itemLabelsHtml +=   '<span class="label sold-out label--' + bcSfFilterConfig.custom.collections_badge_placement + '">'; 
        if (bcSfFilterConfig.custom.collections_badge_soldout) {
            itemLabelsHtml += '<img class="lazyload" src="' + this.optimizeImage(bcSfFilterConfig.custom.collections_badge_soldout, '50x') + '" data-src="' + this.optimizeImage(bcSfFilterConfig.custom.collections_badge_soldout, '{width}x')  + '" ' + 
                                'data-widths="[50,100]" data-aspectratio="' + aspect_ratio + '" data-sizes="auto" ' +
                                'data-expand="600" alt="{{itemTitle}}"' +
                                '>';
        } else {
            itemLabelsHtml += bcSfFilterConfig.label.sold_out;
        }
        
        itemLabelsHtml += '</span>';
    } else if (onSale) {
        itemLabelsHtml +=   '<span class="label sale label--' + bcSfFilterConfig.custom.collections_badge_placement + '">'; 
        if (bcSfFilterConfig.custom.collections_badge_onsale) {
            itemLabelsHtml += '<img class="lazyload" src="' + this.optimizeImage(bcSfFilterConfig.custom.collections_badge_onsale, '50x') + '" data-src="' + this.optimizeImage(bcSfFilterConfig.custom.collections_badge_onsale, '{width}x')  + '" ' + 
                                'data-widths="[50,100]" data-aspectratio="' + aspect_ratio + '" data-sizes="auto" ' +
                                'data-expand="600" alt="{{itemTitle}}"' +
                                '>';
        } else {
            itemLabelsHtml += bcSfFilterConfig.label.sale;
        }
        itemLabelsHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var itemPriceHtml = '';
    if(show_price_on_PLP == 'true'){
        if (onSale) {
            if (priceVaries) {
                itemPriceHtml += '<span class="from">' + bcSfFilterConfig.label.from_price + '</span> ';
            }
            itemPriceHtml += '<span class="original-price money">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span> ';
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        } else {
            if (priceVaries) {
                itemPriceHtml += '<span class="from">' + bcSfFilterConfig.label.from_price + '</span> ';
            }
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        }
        if (this.getProductMetafield(data, 'stamped', 'badge') !== null) {
            itemPriceHtml += '<span class=" stamped-product-reviews-badge" data-product-sku="{{itemHandle}}" data-id="{{itemId}}" style="display:block;">' + this.getProductMetafield(data, 'stamped', 'badge') + '</span>';
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    }
    else{
        if (this.getProductMetafield(data, 'stamped', 'badge') !== null) {
            itemPriceHtml += '<span class=" stamped-product-reviews-badge" data-product-sku="{{itemHandle}}" data-id="{{itemId}}" style="display:block;">' + this.getProductMetafield(data, 'stamped', 'badge') + '</span>';
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    }


    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    //PLP  - Add Height Pseudo Option To SRP Tile
    var productTags = data.tags;
    var productHeightPseudoOption = '';
    var productHeight = '';
    var productOption = '';
    var heightPseudoOption = '';
    if (productTags.length > 0) {
        for (var pTag = 0; pTag < productTags.length ; pTag++) {
            productOption = productTags[pTag].split(":")[0];
            productHeight = productTags[pTag].split(":")[1];
            heightPseudoOption = productOption.concat(productHeight);
            if (heightPseudoOption == 'optionheight') {
                productHeightPseudoOption = productTags[pTag].split(":")[2];
                break;
            }
        }
    }
    if( productHeightPseudoOption != "") {
        var myhtmtoinsert = '<div class="box product"><span class="pseudo-option">' + productHeightPseudoOption + '</span> ';
        itemHtml = itemHtml.replace('<div class="box product">', myhtmtoinsert);
    }

    return itemHtml;
}

BCSfFilter.prototype.buildProductListItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add a specific class for grid item
    var itemImageClass = '';
    if (images.length > 1 && bcSfFilterConfig.custom.product_variant_image_enable) {
        itemImageClass += 'class="product-image view-alt" style="background-image: url(\'' + this.optimizeImage(images[1]['src']) + '\');"';
    } else {
        itemImageClass += 'class="product-image"';
    }
    itemHtml = itemHtml.replace(/{{itemImageClass}}/g, itemImageClass);

    // Add sale label
    var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add sale text
    var itemSaleText = onSale ? bcSfFilterTemplate.saleTextHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleText}}/g, itemSaleText);

    // Add soldOut text
    var itemSoldOutText = soldOut ? bcSfFilterTemplate.soldOutTextHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutText}}/g, itemSoldOutText);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.show_vendors ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor).replace(/{{itemVendorUrl}}/g, this.buildProductItemVendorUrl(data.vendor)) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Price
    var itemPriceHtml = '';
    if(show_price_on_PLP == 'true')
    {
        if (soldOut) {
            itemPriceHtml += '<span class="original-price">';
        }
        if (onSale) {
            if (priceVaries) {
                itemPriceHtml += '<span class="from">' + bcSfFilterConfig.label.from_price + '</span> ';
            }
            itemPriceHtml += '<span class="original-price money">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span> ';
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        } else {
            if (priceVaries) {
                itemPriceHtml += '<span class="from">' + bcSfFilterConfig.label.from_price + '</span> ';
            }
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
        }
        if (soldOut) {
            itemPriceHtml += '</span>';
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    }
    else{
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    }
    // Add wishlist
    var itemWishlistHtml = '';
    if (bcSfFilterConfig.custom.customer_accounts_enabled) {
        var ssw_fave_enabled = 1;
        if (bcSfFilterConfig.custom.fave_enabled) {
            ssw_fave_enabled = bcSfFilterConfig.custom.fave_enabled;
        }
        if (ssw_fave_enabled == 1) {
            itemWishlistHtml += '<div class="ssw-faveiticon sswfaveicon{{itemId}}">' +
                                    '<i data-product-id="{{ productId }}" data-count="0" class="ssw-icon-heart-o ssw-fave-icon ssw-wishlist-element ssw-not-synch"' +
                                    'title="' + bcSfFilterConfig.label.fave + '"' +
                                    'data-params=\'{"product_id":"{{itemId}}","event":"fave_button","page":"product_profile"}\'></i>' +
                                    '<span class="faves-count">...</span>' +
                                '</div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    // Add Description
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
var call_change_method = false;
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = [];
        if(show_price_best_selling_from_sort == 'true'){
            var sortingArr = this.getSortingList();
        }
        else{
            var sortingArr = this.getSortingListwithoutPrice();
        }
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            var index = 0, sortingOption = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
                if(index == 0 ){
                    sortingOption = k;
                    index++;
                }
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);
            if(show_price_best_selling_from_sort == 'true' || !['best-selling', 'price-ascending', 'price-descending'].includes(this.queryParams.sort)){
                // Set current value
                jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
            }
            else{
                // Set the first option of array
                call_change_method = true;
                jQ(this.selector.topSorting + ' select').val(sortingOption).change();                
            }
        }
    }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><span class="icon icon-grid" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-ui-grid" viewBox="0 0 512 512"><path d="M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"/></svg></span><span class="fallback-text">' + bcSfFilterConfig.label.grid_view + '</span></span></a> ';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><span class="icon icon-list" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-ui-list" viewBox="0 0 512 512"><path d="M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"/></svg></span><span class="fallback-text">' + bcSfFilterConfig.label.list_view + '</span></span></a>';
    jQ(this.selector.topDisplayType).html(itemHtml);

    // Active current display type
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
    if (this.queryParams.display == 'list') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
    } else if (this.queryParams.display == 'grid') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
    }
};


// Add additional class when switch to another layout
BCSfFilter.prototype.buildExtrasProductList = function(data) {
    jQ('#bc-sf-filter-products').removeClass();
    if (this.queryParams.display == 'list') {
        jQ('#bc-sf-filter-products').addClass('products products-list');
    } else {
        jQ('#bc-sf-filter-products').addClass('products products-grid');
    }
    if (!bcSfFilterConfig.custom.enable_sidebar) jQ('#bc-sf-filter-products').addClass('full-width')
};

// Build Additional element
BCSfFilter.prototype.buildAdditionalElements = function(data) {
};

function bgset(image){
    var bgset = '';
    if(image){
        var aspect_ratio = image.width / image.height;

        if ( image.width > 180 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180/aspect_ratio) + 'h,';
        if ( image.width > 360 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360/aspect_ratio) + 'h,';
        if ( image.width > 540 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540/aspect_ratio) + 'h,';
        if ( image.width > 720 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720/aspect_ratio) + 'h,';
        if ( image.width > 900 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '900') + ' 900w ' + Math.round(900/aspect_ratio) + 'h,';
        if ( image.width > 1080 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080/aspect_ratio) + 'h,';
        if ( image.width > 1296 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296/aspect_ratio) + 'h,';
        if ( image.width > 1512 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512/aspect_ratio) + 'h,';
        if ( image.width > 1728 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728/aspect_ratio) + 'h,';
        if ( image.width > 1950 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950/aspect_ratio) + 'h,';
        if ( image.width > 2100 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100/aspect_ratio) + 'h,';
        if ( image.width > 2260 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260/aspect_ratio) + 'h,';
        if ( image.width > 2450 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450/aspect_ratio) + 'h,';
        if ( image.width > 2700 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700/aspect_ratio) + 'h,';
        if ( image.width > 3000 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000/aspect_ratio) + 'h,';
        if ( image.width > 3350 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350/aspect_ratio) + 'h,';
        if ( image.width > 3750 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750/aspect_ratio) + 'h,';
        if ( image.width > 4100 ) bgset += ' ' + bcsffilter.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100/aspect_ratio) + 'h,';
        bgset += ' ' + bcsffilter.optimizeImage(image.src, 'master') + ' ' + image.width + 'w ' + image.height + 'h,';
    }
    return bgset;
}

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };


window.onload = function(){
    if(typeof(call_change_method)!= 'undefined' && call_change_method)
    {
        jQ("#bc-sf-filter-top-sorting select").change();
    }
}

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
